module.exports = __webpack_public_path__ + "static/img/logo-black-sm.af81ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-black-sm.png
// module id = +T3F
// module chunks = 5